<template>
  <div>{{ ActDescBtn }}
    <v-container class="pa-0" fluid>
      <v-row class="mx-0" style="height: 48px; max-height: 48px">
        <ContenidoBase
          :EstadoBtn="EstadoBtn"
          :descripcion="'Cuadres de Turnos por Sucursal'"
          :show-absolute="false"
          :titulo="'Cuadres'"
          @MethodGuardar="save"
          @MethodNuevo="limpiar"
          @MethodImprimir="imprimirList" 
          @abrirBarraTablaDinamica="abrirTabla"
        />
      </v-row>

      <v-row>
        <v-col
          v-show="showBarraPrimaria"
          class="pr-0"
          cols="3"
          style="max-height: calc(100vh - 48px - 57px - 64px); overflow-y: scroll"
        >
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <div class="d-flex justify-center">
                <v-btn-toggle>
                  <v-btn color="teal darken-2" dark small text @click.prevent="showFiltroDialog = true">
                    <i class="fa fa-search" style="font-size: 25px"></i>
                    Filtrar
                  </v-btn>
                </v-btn-toggle>
              </div>

              <BarraDinamicaLimitePlus
                :ContListSlot="[
                  { Text: 'Secuencia', NomValue: 'cierrescajasPK', Nv2: 'secuencia', Ctsl: 2, Type: 0, State: true },
                  { Text: 'Estacion', NomValue: 'sucursal', Nv2: 'descripcion', Ctsl: 2, Type: 0, State: true },
                  { Text: 'Caja', NomValue: 'cierrescajasPK', Nv2: 'caja', Ctsl: 2, Type: 0, State: true },
                  { Text: 'Fecha Cierre', NomValue: 'nuevaFechaCierre', Ctsl: 1, Type: 1, State: true },
                  { Text: 'Turno', NomValue: 'turno', Nv2: 'descripcion', Ctsl: 2, Type: 0, State: true },
                ]"
                :PropsList="cuadreList"
                :PropsNombre="'Cuadres'"
                :PropsSeachNombre="'Búsqueda por secuencia'"
                :TbPaginator="paginador"
                :TbTotalItem="totalItems"
                :headers="[]"
                props-search
                @CargarPaginacion="cargarPaginacion"
                @EmitDAta="selectItemBarra"
              />
            </template>
          </v-tooltip>
        </v-col>
        <!-- fn BarraPrimaria ---------------------------------------------------------------------------------->

        <!-- contenido central ------------------------------------------------------------------------------ -->
        <v-col class="mx-2" style="max-height: calc(100vh - 48px - 57px - 64px); overflow-y: scroll">
          <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="">
            <!--- Metadata ---->
            <div class="px-0">
              <v-card class="px-2" color="grey lighten-3">
                <v-row dense>
                  <v-col cols="12" lg="3" md="6" sm="6">
                    <!--- Sucursal ---->
                    <v-autocomplete
                      v-model="cuadre.sucursal"
                      :items="sucursalList"
                      :loading="isSearchingSucursal"
                      :rules="[$rules.required]"
                      dense
                      item-text="descripcion"
                      label="Estaciones"
                      outlined
                      return-object
                      @change="findAllMetroBySucursal"
                      @focus.once="findAllSucursales"
                    >
                      <template v-slot:prepend>
                        <i class="fa fa-sitemap" style="font-size: 1.3rem"></i>
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" lg="3" md="6" sm="6">
                    <!--- Caja ---->
                    <v-autocomplete
                      v-model="cuadre.caja"
                      :items="cajaList"
                      :loading="isSearchingCaja"
                      :rules="[$rules.required]"
                      dense
                      item-text="descripcion"
                      label="Caja"
                      outlined
                      return-object
                      @focus="findCajaBySucursal"
                      @input="setCaja"
                    >
                      <template v-slot:prepend>
                        <i class="fa fa-fax" style="font-size: 1.3rem"></i>
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" lg="2" md="4" sm="4">
                    <!--- Turno ---->
                    <v-autocomplete
                      v-model="cuadre.turno"
                      :items="turnoList"
                      :loading="isSearchingTurno"
                      :rules="[$rules.required]"
                      :search-input.sync="turnoSearch"
                      dense
                      item-text="descripcion"
                      label="Turno"
                      outlined
                      return-object
                    >
                      <template v-slot:prepend>
                        <i class="fa fa-slideshare" style="font-size: 1.3rem"></i>
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" lg="2" md="4" sm="4">
                    <!--- Dia de credito ---->
                    <vue-autonumeric v-model="cuadre.totalventas" dense label="Acumulado del Día" outlined readonly>
                      <template v-slot:prepend>
                        <i class="fa fa-sun-o" style="font-size: 1.3rem"></i>
                      </template>
                    </vue-autonumeric>
                  </v-col>

                  <v-col cols="12" lg="2" md="4" sm="4">
                    <!---- Fecha de ingreso ---->
                    <v-text-field
                      v-model="cuadre.fechacierre"
                      :rules="[$rules.required]"
                      dense
                      label="Fecha"
                      outlined
                      type="date"
                    >
                      <template v-slot:prepend>
                        <i class="fa fa-calendar" style="font-size: 1.3rem"></i>
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-card>
            </div>
            <!--- Fin Metadata ---->

            <v-row class="py-2">
              <!--- Monedas ---->
              <v-col cols="12" md="3" sm="6">
                <div>
                  <v-data-table
                    :headers="headerMoneda"
                    :items="cuadre.denominacionCierrecajaList"
                    :items-per-page="-1"
                    class="elevation-1"
                    color="primary"
                    disable-sort
                    hide-default-footer
                    no-data-text="No hay monedas disponibles"
                    style="border: 1px solid #757575; border-radius: 10px"
                  >
                    <template #item.valor="{ item }">
                      <h3>{{ item.denominacion.valor }}</h3>
                    </template>

                    <template #item.cantidad="{ item }">
                      <vue-autonumeric
                        v-model="item.cantidad"
                        :an-options="{ decimalPlaces: 0, minimumValue: 0 }"
                        class="align-center"
                        dense
                        hide-details
                        outlined
                        @change="changeTotal(item)"
                      ></vue-autonumeric>
                    </template>

                    <template #item.total="{ item }">
                      <h3 class="align-center" style="color: cornflowerblue">RD${{ item.total }}</h3>
                    </template>

                    <template #body.append>
                      <td></td>
                      <td class="text-end"><h3>Total:</h3></td>
                      <td>
                        <h3>RD${{ totalDenominaciones }}</h3>
                      </td>
                    </template>
                  </v-data-table>

                  <!--- Informacion de Modificacion ---->
                  <div v-if="this.cuadre.fechaModificacion" class="my-4">
                    <div>
                      <p>
                        Usuario de Modificacion:
                        <b>{{ this.cuadre.usuarioModificacion.usuario }}</b>
                      </p>
                    </div>
                    <div>
                      <p>
                        Fecha de Modificacion:
                        <b>{{ this.cuadre.fechaModificacion }}</b>
                      </p>
                    </div>
                  </div>
                  <!--- Fin Informacion de Modificacion ---->

                  <div class="mt-4 ml-4 diferencia-cuadre-row">
                    <span>Diferencia Cuadre:</span>
                    <VueAutonumeric
                      v-model="diferenciaCuadre"
                      :an-options="{ decimalPlaces: 3 }"
                      class="diferencia-cuadre-field"
                      dense
                      hide-details
                      outlined
                      readonly
                    />
                  </div>
                </div>
              </v-col>
              <!--- Fin Monedas ---->

              <!--- Informacion de Ventas ---->
              <v-col id="informacion-ventas" class="px-0" cols="12" md="2" sm="6" style="max-height: 40%">
                <v-card class="pa-2" color="grey lighten-3">
                  <VueAutonumeric
                    v-if="isEstacionGas"
                    v-model="cuadre.valorgaspremium"
                    :an-options="{ decimalPlaces: 2, minimumValue: 0 }"
                    dense
                    hide-details
                    label="Gas Premium (INFO)"
                    on-options
                    outlined
                    small
                  >
                    <template #prepend>
                      <i class="fa fa-free-code-camp" style="font-size: 1.3rem; width: 1.3rem"></i>
                    </template>
                  </VueAutonumeric>

                  <VueAutonumeric
                    v-model="cuadre.valorventascredito"
                    :an-options="{ decimalPlaces: 2, minimumValue: 0 }"
                    dense
                    hide-details
                    label="Ventas a Crédito"
                    outlined
                  >
                    <template #prepend>
                      <i class="fa fa-shopping-cart" style="font-size: 1.3rem; width: 1.3rem"></i>
                    </template>
                  </VueAutonumeric>

                  <VueAutonumeric
                    v-model="cuadre.valortarjetascredito"
                    :an-options="{ decimalPlaces: 2, minimumValue: 0 }"
                    dense
                    hide-details
                    label="Tarjeta de Crédito:"
                    outlined
                  >
                    <template #prepend>
                      <i class="fa fa-credit-card" style="font-size: 1.3rem; width: 1.3rem"></i>
                    </template>
                  </VueAutonumeric>

                  <VueAutonumeric
                    v-model="cuadre.valorcheques"
                    :an-options="{ decimalPlaces: 2, minimumValue: 0 }"
                    dense
                    hide-details
                    label="Valor en Cheques"
                    outlined
                  >
                    <template v-slot:prepend>
                      <i class="fa fa-money" style="font-size: 1.3rem; width: 1.3rem"></i>
                    </template>
                  </VueAutonumeric>

                  <VueAutonumeric
                    v-if="isEstacionGas"
                    v-model="cuadre.valorbonogas"
                    :an-options="{ decimalPlaces: 2, minimumValue: 0 }"
                    dense
                    hide-details
                    label="Valor en BonoGas"
                    outlined
                  >
                    <template v-slot:prepend>
                      <i class="fa fa-money" style="font-size: 1.3rem; width: 1.3rem"></i>
                    </template>
                  </VueAutonumeric>

                  <VueAutonumeric
                    v-model="cuadre.valorpagocomision"
                    :an-options="{ decimalPlaces: 2, minimumValue: 0 }"
                    dense
                    hide-details
                    label="Pagos por Comisión"
                    outlined
                  >
                    <template v-slot:prepend>
                      <i class="fa fa-money" style="font-size: 1.3rem; width: 1.3rem"></i>
                    </template>
                  </VueAutonumeric>

                  <VueAutonumeric
                    v-model="cuadre.donaciones"
                    :an-options="{ decimalPlaces: 2, minimumValue: 0 }"
                    dense
                    hide-details
                    label="Valor Donaciones"
                    outlined
                  >
                    <template v-slot:prepend>
                      <i class="fa fa-money" style="font-size: 1.3rem; width: 1.3rem"></i>
                    </template>
                  </VueAutonumeric>

                  <VueAutonumeric
                    v-model="cuadre.valorotros"
                    :an-options="{ decimalPlaces: 2, minimumValue: 0 }"
                    dense
                    hide-details
                    label="Valor Otros"
                    outlined
                  >
                    <template v-slot:prepend>
                      <i class="fa fa-money" style="font-size: 1.3rem; width: 1.3rem"></i>
                    </template>
                  </VueAutonumeric>

                  <VueAutonumeric
                    v-model="cuadre.valorasignaciones"
                    :an-options="{ decimalPlaces: 2, minimumValue: 0 }"
                    dense
                    hide-details
                    label="Valor Asignaciones:"
                    outlined
                  >
                    <template v-slot:prepend>
                      <i class="fa fa-money" style="font-size: 1.3rem; width: 1.3rem"></i>
                    </template>
                  </VueAutonumeric>

                  <VueAutonumeric
                    v-model="cuadre.valorcreditodistribuidora"
                    :an-options="{ decimalPlaces: 2, minimumValue: 0 }"
                    dense
                    hide-details
                    label="Crédito Distribuidora:"
                    outlined
                  >
                    <template v-slot:prepend>
                      <i class="fa fa-credit-card-alt" style="font-size: 1.3rem; width: 1.3rem"></i>
                    </template>
                  </VueAutonumeric>

                  <VueAutonumeric
                    v-model="cuadre.valordistribuidora"
                    :an-options="{ decimalPlaces: 2, minimumValue: 0 }"
                    dense
                    hide-details
                    label="Distribuidoras:"
                    outlined
                  >
                    <template v-slot:prepend>
                      <i class="fa fa-truck" style="font-size: 1.3rem; width: 1.3rem"></i>
                    </template>
                  </VueAutonumeric>

                  <VueAutonumeric
                    v-if="isEstacionGas"
                    v-model="cuadre.pruebasmetro"
                    :an-options="{ decimalPlaces: 2, minimumValue: 0 }"
                    dense
                    hide-details
                    label="Pruebas Metros"
                    outlined
                  >
                    <template v-slot:prepend>
                      <i class="fa fa-bookmark" style="font-size: 1.3rem; width: 1.3rem"></i>
                    </template>
                  </VueAutonumeric>

                  <VueAutonumeric
                    v-if="isEstacionGas"
                    v-model="cuadre.valorTraspaso"
                    :an-options="{ decimalPlaces: 2, minimumValue: 0 }"
                    dense
                    hide-details
                    label="Traspasos"
                    outlined
                  >
                    <template v-slot:prepend>
                      <i class="fa fa-money" style="font-size: 1.3rem; width: 1.3rem"></i>
                    </template>
                  </VueAutonumeric>

                  <VueAutonumeric
                    v-model="cuadre.valordescuento"
                    :an-options="{ decimalPlaces: 2, minimumValue: 0 }"
                    dense
                    hide-details
                    label="Descuento (INFO)"
                    outlined
                  >
                    <template v-slot:prepend>
                      <i class="fa fa-bookmark" style="font-size: 1.3rem; width: 1.3rem"></i>
                    </template>
                  </VueAutonumeric>

                  <hr class="my-3" style="border-bottom: 2px dashed #212121" />

                  <VueAutonumeric v-model="totalDelDia" dense hide-details label="Total del Día" outlined readonly>
                    <template v-slot:prepend>
                      <i class="fa fa-money" style="font-size: 1.3rem; width: 1.3rem"></i>
                    </template>
                  </VueAutonumeric>

                  <VueAutonumeric
                    v-model="totalDenominaciones"
                    dense
                    hide-details
                    label="Depósito Bancario:"
                    outlined
                    readonly
                  >
                    <template v-slot:prepend>
                      <i class="fa fa-money" style="font-size: 1.3rem; width: 1.3rem"></i>
                    </template>
                  </VueAutonumeric>

                  <VueAutonumeric v-model="totalGeneral" dense hide-details label="Total General" outlined readonly>
                    <template v-slot:prepend>
                      <i class="fa fa-money" style="font-size: 1.3rem; width: 1.3rem"></i>
                    </template>
                  </VueAutonumeric>
                </v-card>
              </v-col>
              <!--- Fin Informacion de Ventas ---->
<!-- filterlecturasMetroCierreList(cuadre.lecturasMetroCierreList) -->
              <!--- Metros ---->
              <v-col cols="12" md="7">
                <div>
                  <v-data-table
                    :headers="metroHeaders"
                    :items="cuadre.lecturasMetroCierreList"
                    :items-per-page="-1"
                    :loading="isSearchingMetros"
                    class="elevation-1"
                    dense
                    disable-sort
                    hide-default-footer
                    no-data-text="No hay metros disponibles"
                    style="border: 1px solid #757575; border-radius: 10px; max-height: inherit; overflow-y: scroll"
                  >
                    <template #item.lecturaInicial="{ item }">
                      {{ formatNumber(item.lecturaInicial) }}
                    </template>

                    <template #item.lecturaFinal="{ item }">
                    <!--vue-autonumeric  -->
                      <vue-autonumeric
                        v-model.number="item.lecturaFinal"
                        :an-options="{ decimalPlaces: 3 }"
                        class="align-center"
                        dense
                        hide-details
                        outlined
                        @change="changeDiferencia(item)"
                      ></vue-autonumeric>
                    </template>

                    <template #item.diferencia="{ item }">
                      {{ formatNumber(item.diferencia) }}
                    </template>

                    <template #item.llenador="{ item }">
                      <v-autocomplete
                        v-model="item.llenador"
                        :items="item.llenadorList"
                        :search-input.sync="item.searchLlenador"
                        dense
                        hide-details
                        item-text="nombre"
                        no-filter
                        outlined
                        return-object
                        @blur="checkEmptyLlenadorList(item)"
                        @focus="updateLlenadorList(item, '')"
                        @keyup.capture="updateLlenadorList(item)"
                      ></v-autocomplete>
                    </template>

                    <template #body.append>
                      <tr v-if="cuadre.lecturasMetroCierreList.length > 0 && !isEstacionGas" class="elevation-1">
                        <td colspan="3">
                          <h4>Total Galones Vendidos:</h4>
                        </td>
                        <td>
                          <h4>{{ formatNumber(totalesGalones.combisa) }}</h4>
                        </td>
                      </tr>

                      <tr v-if="cuadre.lecturasMetroCierreList.length > 0 && isEstacionGas" class="elevation-1">
                        <td colspan="3">
                          <h4>Total Galones Vendidos:</h4>
                          <h4>Total Galones Vendidos Gas Premium:</h4>
                          <h4>Total Galones Vendidos Gas Regular:</h4>
                        </td>
                        <td>
                          <h4>{{ formatNumber(totalesGalones.vendido) }}</h4>
                          <h4>{{ formatNumber(totalesGalones.gasPremium) }}</h4>
                          <h4>{{ formatNumber(totalesGalones.gasRegular) }}</h4>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </div>
              </v-col>
              <!--- Fin Metros ---->
            </v-row>

            <ResumenGas v-if="isEstacionGas" :cuadre="cuadre" />
            <ResumenGasolina v-else :cuadre="cuadre" />

          </v-form>
        </v-col>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
      </v-row>
    </v-container>
    <!-- Modales -------------------------------------------------------------------------------------------------->
    <!-- ------------------------------------------------------ Modal-Filtro tb-datos -->
    <v-dialog
      v-model="showFiltroDialog"
      label="Modal agregar factura"
      max-height="50%"
      max-width="60%"
      persistent
      transition="fab-transition"
    >
      <v-card>
        <v-toolbar color="indigo" dense flat>
          <i class="" style="font-size: 20px"></i>
          <v-toolbar-title class="font-weight-light" style="color: white">
            <b>FILTROS</b>
          </v-toolbar-title>
          <i class="" style="font-size: 20px"></i>

          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small @click.prevent="showFiltroDialog = false">
            <i class="fa fa-close" style="font-size: 20px; color: white"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <br />

          <v-row>
            <v-col cols="12" md="12">
              <!--- Sucursal Filtro ---->
              <v-autocomplete
                v-model="filtro.sucursal"
                :items="sucursalList"
                :loading="isSearchingSucursal"
                clearable
                dense
                item-text="descripcion"
                item-value="codigo"
                label="Estaciones"
                outlined
                @focus.once="findAllSucursales"
              >
                <template v-slot:prepend>
                  <i class="fa fa-sitemap" style="font-size: 1.3rem"></i>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn-toggle dense rounded>
            <v-btn color="#90A4AE" @click.prevent="cleanFiltro">
              <i class="fa fa-file-o" style="font-size: 28px"></i>
              Limpiar filtro
            </v-btn>

            <v-btn color="blue lighten-1" @click.prevent="searchFiltro">
              <i class="fa fa-search" style="font-size: 28px"></i>
              Buscar
            </v-btn>
          </v-btn-toggle>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal-Filtro tb-datos -->
  
  <!-- ------------------------------------------------------ Modal-Reportes-ModalReporteFiltros -->
    <v-dialog transition="fab-transition" label="Modal agregar cuenta" v-model="dialogimprimirListFilt" persistent
      max-width="80%" max-height="50%">
      <!----------------------------------------------------------------- Cuerpo Reporte -->
      <v-card color="grey lighten-3">
        <v-toolbar flat color="#BDBDBD" dense style="border: 1px solid #000000">
          <v-avatar tile size="45">
            <img src="@/assets/iconos_micromarket/custom-reports.png" alt="Reporte" />
          </v-avatar>
          <span class="font-weight-light" style="font-size: 20px">
            <b>REPORTE CUADRES </b>
          </span>

          <v-spacer></v-spacer>
          <v-btn color="red" fab small @click.prevent="dialogimprimirListFilt = false">
            <i style="font-size: 20px; color: white" class="fa fa-close"></i>
          </v-btn>
        </v-toolbar>

        <hr />

        <v-container style="border: 1px solid #000000">
          <v-form ref="formImpList" @submit.prevent="" v-model="valid" lazy-validation>
            <v-row class="pa-0 ma-0">

              <v-col cols="12" md="12" sm="12">
            
                      <v-switch class="mt-0" hide-details
                      color="teal" label=""
                        v-model="datosImprecionAll.cierreDia" >
                                                      <template v-slot:label>
                                                        <strong v-if="datosImprecionAll.cierreDia == true"
                                                          style="color: #000000; font-size: 13px">
                                                          CIERRE DEL DÍA: Si
                                                        </strong>
                                                        <strong v-if="datosImprecionAll.cierreDia == false"
                                                          style="color: #000000; font-size: 13px">
                                                          CIERRE DEL DÍA: No
                                                        </strong>
                                                      </template>
                                                    </v-switch>


              </v-col>


              <v-col cols="12" md="6" sm="6">
             
              </v-col>

              <v-col cols="12" md="6" sm="6">
          
              </v-col>

            



            </v-row>
          </v-form>
        </v-container>
        <hr />
        <ModalReporteFiltros :propsBtnImprimir="true" :propsBtnExel="false" :propsBtnCorreo="false" @DataReporteBasico="DDataReporteBasico" ref="ModRepFilt" :Datos="datosImprecionAll" />
      </v-card>
      <!-------------------------------------------------------------------------------- Fn Cuerpo Reporte -->
    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal-Reportes-ModalReporteFiltros -->

  
  
    <!------------otras funciones---------------->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      :timeout="120000"
      :vertical="true"
      style="margin-top: 20%"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>
    <!-- fn Modales ----------------------------------------------------------------------------------------------->
  </div>
</template>

<script>
  import BarraBusqueda2 from "../../components/BarraBusquedaDinam"
  import VueAutonumeric from "../../components/AutoNumericNuevo"
  import ContenidoBase from "../../components/ContenidoBase"
  import BarraDinamicaLimitePlus from "@/components/BarraDinamicaLimitePlus.vue"
  import { EventBus } from "@/event-bus"
  import ResumenGas from "@/Estacion/Componentes/ResumenGas.vue"
  import ResumenGasolina from "@/Estacion/Componentes/ResumenGasolina.vue"
  import ModalReporteFiltros from "../../components/ModalReporteFiltros";
import AutoNumericNuevoWithOptions from "@/components/AutoNumericNuevoWithOptions.vue"
  export default {
    components: {
      ResumenGasolina,
      ResumenGas,
      BarraDinamicaLimitePlus,
      BarraBusqueda2,
      VueAutonumeric,
      ContenidoBase,
      ModalReporteFiltros,
      AutoNumericNuevoWithOptions
    },

    mounted() {
      this.findAllMonedas()
      this.findAllSucursales()
      this.findAllCuadre()
      this.$nextTick(() => {
        this.initDetalle()
      })
    },

    data() {
      return {

        dialogimprimirListFilt: false,
       datosImprecionAll: {
        nombre: "REPORTE CUADRES",
        UrlImprimir: "/cierrecaja/imprimirListCierreEstacion",
        UrlExel: "/cierrecaja/excelListCierreEstacion",
        UrlCorreo: "/cierrecaja/CorreoListCierreEstacion",
        secuencia:0,
        caja:0,
        cierreDia: false,
        estacionGas: this.$store.getters.GetConfiguracionGeneral.config.estacion,
        estacionCombustible: this.$store.getters.GetConfiguracionGeneral.config.estacionCombustible,
        fechacuadre:null
        
      },



        lecturaMetroCierreNuevo: {
          metro: null,
          lecturaInicial: 0,
          lecturaFinal: 0,
          diferencia: 0,
        },

        lecturaMetroCierre: {
          metro: null,
          lecturaInicial: 0,
          lecturaFinal: 0,
          diferencia: 0,
        },

        cuadreNuevo: {
          cierrescajasPK: {
            secuencia: 0,
            caja: 0,
          },

          sucursal: null,
          caja: null,
          turno: null,
          totalventas: 0,
          fechacierre: new Date().toISOString().split("T")[0],
          fecha: null,

          lecturasMetroCierreList: [],
          denominacionCierrecajaList: [],
          cierrecajaMonedaList: [],

          valorgaspremium: 0,
          valorventascredito: 0,
          valortarjetascredito: 0,
          valorcheques: 0,
          valorbonogas: 0,
          valorpagocomision: 0,
          donaciones: 0,
          valorotros: 0,
          valorasignaciones: 0,
          valorcreditodistribuidora: 0,
          valordistribuidora: 0,
          pruebasmetro: 0,
          valorTraspaso: 0,
          valordescuento: 0,

          inventariofisico: 0,
          comprasdomestico: 0,
          salidasgas: 0,

          totalexistenciafisica: 0,
          inventariofisicofinal: 0,
          diferenciatotal: 0,

          detalles: [],
        },

        cuadre: {
          cierrescajasPK: {
            secuencia: 0,
            caja: 0,
          },

          sucursal: null,
          caja: null,
          turno: null,
          totalventas: 0,
          fechacierre: new Date().toISOString().split("T")[0],
          fecha: null,

          lecturasMetroCierreList: [],
          denominacionCierrecajaList: [],
          cierrecajaMonedaList: [],

          valorgaspremium: 0,
          valorventascredito: 0,
          valortarjetascredito: 0,
          valorcheques: 0,
          valorbonogas: 0,
          valorpagocomision: 0,
          donaciones: 0,
          valorotros: 0,
          valorasignaciones: 0,
          valorcreditodistribuidora: 0,
          valordistribuidora: 0,
          pruebasmetro: 0,
          valorTraspaso: 0,
          valordescuento: 0,

          inventariofisico: 0,
          comprasdomestico: 0,
          salidasgas: 0,

          totalexistenciafisica: 0,
          inventariofisicofinal: 0,
          diferenciatotal: 0,

          detalles: [],
        },

        cuadreList: [],
        diferenciaCuadre: 0,
        totalItems: 0,
        searchCierre: 0,
        paginador: {
          page: 1,
          itemsPerPage: 5,
          pageStart: 1,
          pageStop: 15,
          pageCount: 10,
          itemsLength: 5,
        },

        isSearchingMonedas: false,
        headerMoneda: [
          { text: "Moneda", value: "valor", width: "30%",class: ['no-gutters black--text'] },
          { text: "Cantidad", value: "cantidad", width: "30%",class: ['no-gutters black--text'] },
          { text: "Valor", value: "total", width: "auto",class: ['no-gutters black--text'] },
        ],

        metroList: [],
        isSearchingMetros: false,
        metroHeaders: [
          { text: "Metros", value: "metro.nombre", width: "auto", class: ['no-gutters black--text'] },
          { text: "Tipo Gas", value: "metro.tipoGas.descripcion", width: "auto",class: ['no-gutters black--text'] },
          { text: "Lecturas Iniciales", value: "lecturaInicial", width: "auto", class: ['no-gutters black--text'] },
          { text: "Lecturas Finales", value: "lecturaFinal", width: "auto",class: ['no-gutters black--text'] },
          { text: "Diferencias", value: "diferencia", width: "auto",class: ['no-gutters black--text'] },
          { text: "Llenador", value: "llenador", width: "auto",class: ['no-gutters black--text'] },
        ],

        sucursalList: [],
        isSearchingSucursal: false,

        cajaList: [],
        isSearchingCaja: false,

        turnoList: [],
        turnoSearch: "",
        isSearchingTurno: false,

        showBarraPrimaria: false,
        isLoading: false,
        showFiltroDialog: false,
        filtro: {
          sucursal: null,
        },

        EstadoBtn: {
          BarraTablaDinamicaAprir: true,
          nuevo: true,
          guardar: true,
          eliminar: false,
          anular: false,
          imprimir: false,
        },

        valid: true,

        notif: {
          estado: false,
          nombre: "",
          Exec: "",
        },

        aalert: {
          estado: false,
          color: null,
        },
      }
    },

    methods: {
      abrirTabla() {
        this.showBarraPrimaria = !this.showBarraPrimaria
        if (this.showBarraPrimaria == true) {
        this.searchFiltro();
      }
      },

      selectItemBarra(item) {
        const { secuencia, caja } = item.cierrescajasPK
        this.$axios
          .get(this.$hostname + this.$hName + `/cierrecaja/findById/${caja}/${secuencia}`, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((response) => {
            this.cargarCuadreSeleccionado(response.data)
          })
          .catch((error) => {
            console.error(error)
            this.alerta("Error al cargar el cuadre seleccionado", "error")
          })
      },

      cargarCuadreSeleccionado(item) {
        Object.keys(this.cuadre).forEach((key) => {
          this.cuadre[key] = item[key]
        })

        if (Object.hasOwn(item, "fechaModificacion")) {
          this.cuadre.fechaModificacion = item.fechaModificacion
          this.cuadre.usuarioModificacion = item.usuarioModificacion
        }

        this.cuadre.denominacionCierrecajaList.forEach((item) => {
          item.total = item.cantidad * item.denominacion.valor
        })

        this.findCajaBySucursal()
        this.findAllTurnos()

        /*if (item.fechacierre) {
          this.cuadre.fechacierre = new Date(item.fechacierre).toISOString().split("T")[0]
        }*/
        this.cuadre.fechacierre = item.nuevaFechaCierre
        item.lecturasMetroCierreList.forEach((lectura) => {
          lectura.llenadorList = [lectura.llenador]
          lectura.searchLlenador = ""
        })
        this.loadDiferenciaCuadre()
      },

      cleanFiltro() {
        this.filtro = {
          sucursal: null,
        }
        this.searchFiltro()
      },

      searchFiltro() {
        this.paginador.page = 1
        this.paginador.itemsPerPage = 10
        this.cargarPaginacion(this.paginador, this.searchCierre)
        this.showFiltroDialog = false
      },

      /**
       * Se llama cuando el usuario cambia la página de la barra lateral.
       * @param {object} paginador - Informacion de la pagina actual
       * @param {string} search - Parametro de busqueda en la barra
       **/
      cargarPaginacion(paginador, search) {
        this.paginador = JSON.parse(JSON.stringify(paginador))
        this.searchCierre = search
        this.findAllCuadre()
      },

      /**
       * Busca todos los cuadres y rellena los items de la barra lateral.
       **/
      findAllCuadre() {
        let limit = this.paginador.itemsPerPage
        let ultimo = this.paginador.pageStart
        let cierre = this.searchCierre <= 0 ? null : this.searchCierre
        let sucursal = this.filtro.sucursal ? this.filtro.sucursal : null
        this.$axios
          .get(
            this.$hostname +
              this.$hName +
              `/cierrecaja/findListCierrecajaPlus/${limit}/${ultimo}/${cierre}/${sucursal}/null/null/null/null`,
            {
              headers: this.$store.getters.GetheadersAxios,
            }
          )
          .then((response) => {
            this.cuadreList = response.data.ListItems
            this.totalItems = response.data.TbTotalItem
          })
          .catch((error) => {
            console.error(error)
          })
      },

      datostabla(e) {},

      save() {
        if (this.$refs.form.validate()) {
          this.isLoading = true
          EventBus.$emit("loading", true)
          this.$axios
            .post(this.$hostname + this.$hName + "/cierrecaja/saveOrUpdate/", this.cuadre, {
              headers: this.$store.getters.GetheadersAxios,
            })
            .then((response) => {
              this.alerta("Cuadre guardado exitosamente!", "bien")
              this.limpiar()
            })
            .catch((error) => {
              console.error(error)
              this.alerta("Error al guardar el cuadre!", "error")
            })
            .finally(() => {
              this.isLoading = false
              EventBus.$emit("loading", false)
            })
        } else {
          this.alerta("Los campos en rojo son requeridos", "error")
        }
      },

      limpiar() {
        Object.assign(this.cuadre, this.cuadreNuevo)
        this.diferenciaCuadre = 0
        this.$refs.form.resetValidation()
        this.cajaList = []
        this.cuadre.denominacionCierrecajaList = []
        this.findAllMonedas()
        this.initDetalle()
        this.cuadre.usuarioModificacion = null
        this.cuadre.fechaModificacion = null
      },

      /**
       * Muestra una alerta en un dialogo
       * @param {string} mensaje - Mensaje a mostrar
       * @param {string} estado - Estado "bien" o "error"
       */
      alerta(mensaje, estado) {
        this.aalert.nombre = mensaje
        this.aalert.estado = true
        this.aalert.color = estado === "bien" ? "success" : "error"
      },

      findAllSucursales() {
        this.isSearchingSucursal = true

        this.$axios
          .get(this.$hostname + this.$hName + "/sucursal", {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              page: 0,
              size: 100,
            },
          })
          .then((response) => {
            this.sucursalList = response.data.content
          })
          .catch((error) => {
            console.error(error)
          })
          .finally(() => {
            this.isSearchingSucursal = false
          })
      },

      findCajaBySucursal() {
        if (this.cuadre.sucursal === null) {
          this.alerta("Seleccione una sucursal", "error")
          return
        }
        this.isSearchingCaja = true
        let codigo = this.cuadre.sucursal.codigo

        this.$axios
          .get(this.$hostname + this.$hName + "/cajas/find/sucursal/" + codigo, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((response) => {
            this.cajaList = response.data
            this.cuadre.caja = this.cajaList.find((caja) => caja.codigo === this.cuadre.cierrescajasPK.caja)
          })
          .catch((error) => {
            console.error(error)
          })
          .finally(() => {
            this.isSearchingCaja = false
          })
      },

      findAllTurnos() {
        this.isSearchingTurno = true

        this.$axios
          .get(this.$hostname + this.$hName + "/turnos-trabajo", {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              descripcion: this.turnoSearch,
              page: this.paginador.page - 1,
            },
          })
          .then((response) => {
            this.turnoList = response.data.content
          })
          .catch((error) => {
            console.error(error)
          })
          .finally(() => {
            this.isSearchingTurno = false
          })
      },

      findAllMonedas() {
        this.isSearchingMonedas = true
        this.$axios
          .get(this.$hostname + this.$hName + "/denominacionmoneda/findallActivos/", {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((response) => {
            this.initCierreEstacionDenominacion(response.data)
          })
          .catch((error) => {
            console.error(error)
          })
          .finally(() => {
            this.isSearchingMonedas = false
          })
      },

      findAllMetroBySucursal() {
        this.cuadre.lecturasMetroCierreList = []
        if (this.cuadre.sucursal === null) {
          return
        }

        this.isSearchingMetros = true
        let codigoSucursal = this.cuadre.sucursal.codigo

        this.$axios
          .get(this.$hostname + this.$hName + `/metros-estacion/${codigoSucursal}`, {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              size: 100,
            },
          })
          .then((response) => {

            this.initLecturasMetroCierre(response.data.content.filter((ee) => ee.borrado!=null && ee.borrado==false))
          })
          .catch((error) => {
            console.error(error)
          })
          .finally(() => {
            this.isSearchingMetros = false
          })
      },

      initLecturasMetroCierre(data) {
        data.sort((a, b) => a.posicion - b.posicion)

        data.forEach((value) => {
          let valorInit = parseFloat(value.lecturaInicial.replace(/,/g, ""))
          this.cuadre.lecturasMetroCierreList.push({
            metro: value,
            lecturaInicial: valorInit,
            lecturaFinal: valorInit,
            diferencia: 0,
            llenador: value.llenador,
            searchLlenador: "",
            llenadorList: [value.llenador],
            borrado:false
          })
        })
      },

      initCierreEstacionDenominacion(data) {
        data.forEach((item) => {
          this.cuadre.denominacionCierrecajaList.push({
            denominacion: item,
            cantidad: 0,
            total: 0,
          })
        })
      },

      changeTotal(item) {
        item.total = item.cantidad * item.denominacion.valor
      },

      changeDiferencia(item) {
        if (item.lecturaFinal < item.lecturaInicial) {
          this.alerta("La lectura final no puede ser menor a la inicial", "error")
          item.lecturaFinal = item.lecturaInicial
        }
        item.diferencia = item.lecturaFinal - item.lecturaInicial
      },

      setCaja(caja) {
        this.setPKCierre(caja)
        this.initCierreAnterior(caja)
      },

      initCierreAnterior(caja) {
        this.$axios
          .get(this.$hostname + this.$hName + `/cierrecaja/lastCierre`, {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              caja: caja.codigo,
            },
          })
          .then((response) => {
            let cierreAnterior = response.data
            if (cierreAnterior) {
              this.cuadre.inventariofisico = cierreAnterior.inventariofisicofinal || 0
              this.cuadre.totalventas = isNaN(this.calculateAcumuladoDia(cierreAnterior))
                ? 0
                : this.calculateAcumuladoDia(cierreAnterior)
              this.setLecturasInicialesCierreAnterior(cierreAnterior)
              this.setResumenCierreAnterior(cierreAnterior)
            }
          })
          .catch((error) => {
            console.error(error)
          })
      },

      setResumenCierreAnterior(cierreAnterior) {
        if (this.isEstacionGas) return

        //NOTA: EL IF LO PUSE PORQUE AL HACER UN NUEVO "CUADRE.DETALLE NO HAY"
        if(this.cuadre.detalles.length>0){
          cierreAnterior.detalles.forEach((detalle) => {
          this.cuadre.detalles.find((item) => item.tipo.codigo === detalle.tipo.codigo).inventarioInicial = detalle.inventarioFinal
        })
        }else{

        Promise.all(cierreAnterior.detalles.map(async (element) => { 
          var OBJ_ELEM={
            asignaciones: 0,
            compras: 0,
            diferencia:0,
            donaciones: 0,
            existenciaLibro:0,
            id:0,
            inventarioFinal:0,
            //inventarioInicial:element.inventarioInicial,
            inventarioInicial:element.inventarioFinal,
            prueba: 0,
            salidas: 0,
            tipo:element.tipo
          }
          this.cuadre.detalles.push(OBJ_ELEM)

        }))
         // this.cuadre.detalles= JSON.parse(JSON.stringify(cierreAnterior.detalles))
        }
       


      },

      setLecturasInicialesCierreAnterior(caja) {
        caja.lecturasMetroCierreList.forEach((lectura, index) => {
          this.cuadre.lecturasMetroCierreList.find((item) => item.metro.codigo === lectura.metro.codigo).lecturaInicial = lectura.lecturaFinal
          this.cuadre.lecturasMetroCierreList.find((item) => item.metro.codigo === lectura.metro.codigo).lecturaFinal =lectura.lecturaFinal
        })
      },

      calculateAcumuladoDia(caja) {
        if (new Date(caja.fecha + "T00:00:00").getDay() !== new Date().getDay()) return
        let acumulado = 0
        caja.lecturasMetroCierreList.forEach((lectura) => {
          acumulado += lectura.diferencia
        })
        return acumulado + caja.totalventas
      },

      setPKCierre(caja) {
        let codigo = caja.codigo
        this.$axios
          .get(this.$hostname + this.$hName + `/cierrecaja/ultimocierre/${codigo}/`, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((response) => {
            this.cuadre.cierrescajasPK = {
              secuencia: response.data,
              caja: codigo,
            }
          })
          .catch((error) => {
            console.error(error)
          })
      },

      findLlenadorModificar(item, nombre = item.searchLlenador) {
        if (!this.cuadre.sucursal || !this.cuadre.sucursal.codigo) {
          return Promise.resolve([])
        }

        return this.$axios
          .get(this.$hostname + this.$hName + "/vendedores/findAllByNombre", {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              nombre: nombre || "",
              sucursal: this.cuadre.sucursal.codigo,
            },
          })
          .then((res) => {
            return res.data.content
          })
          .catch((err) => {
            console.error(err)
          })
      },

      async updateLlenadorList(item, nombre = item.searchLlenador) {
        clearTimeout(this.searchTimeout)
        this.searchTimeout = setTimeout(async () => {
          const data = await this.findLlenadorModificar(item, nombre)

          // Create an updated item object
          const updatedItem = { ...item, llenadorList: data || [] }

          // Find the index of the item to be updated
          const itemIndex = this.cuadre.lecturasMetroCierreList.findIndex(
            (lectura) => lectura.metro.codigo === item.metro.codigo
          )

          if (itemIndex > -1) {
            // Replace the item in the array with the new one
            this.cuadre.lecturasMetroCierreList.splice(itemIndex, 1, updatedItem)
          }
        }, 300)
      },

      checkEmptyLlenadorList(item) {
        if (item.llenadorList.length === 0 || !item.llenadorList.includes(item.llenador)) {
          item.llenadorList.unshift(item.llenador)
        }
      },

      async initDetalle() {
        if (this.isEstacionGas) return
        const departamentos = await this.findAllDepartamentos()
        this.cuadre.detalles = []

        const detalle = {
          tipo: 0,
          asignaciones: 0,
          donaciones: 0,
          prueba: 0,
          inventarioInicial: 0,
          inventarioFinal: 0,
          diferencia: 0,
          compras: 0,
          salidas: 0,
          existenciaLibro: 0,
        }
        departamentos.forEach((departamento) => {
          detalle.tipo = departamento
          this.cuadre.detalles.push({ ...detalle })
        })
      },

      findAllDepartamentos() {
        return this.$axios.get(this.$hostname + this.$hName + "/departamento/activo").then((res) => {
          return res.data
        })
      },

      formatNumber(item) {
        if(item==null){
          item=0
        }

        return item.toLocaleString("en-US", {
          minimumFractionDigits: 3,
          maximumFractionDigits: 3,
        })
      },

      loadInformacionVentas() {
        if (!this.cuadre.caja || !this.cuadre.turno || !this.cuadre.sucursal || !this.cuadre.fechacierre || this.cuadre.fecha) return

        this.$axios
          .get(this.$hostname + this.$hName + "/cierrecaja/informacionVentas", {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              caja: this.cuadre.caja.codigo,
              turno: this.cuadre.turno.codigo,
              sucursal: this.cuadre.sucursal.codigo,
              fecha: this.cuadre.fechacierre,
            },
          })
          .then((response) => {
            this.asignarInformacionVenta(response.data)
          })
          .catch((error) => {
            console.error(error)
          })
      },

      loadDiferenciaCuadre() {
        const cierre = this.cuadre.cierrescajasPK ? this.cuadre.cierrescajasPK.secuencia : 0
        const caja = this.cuadre.cierrescajasPK ? this.cuadre.cierrescajasPK.caja : 0

        if (!caja || !cierre) {
          this.diferenciaCuadre = 0
          return
        }

        this.$axios
          .get(this.$hostname + this.$hName + "/cierrecaja/diferenciaCuadre", {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              caja,
              cierre,
            },
          })
          .then((response) => {
            this.diferenciaCuadre = response.data || 0
          })
          .catch((error) => {
            console.error(error)
            this.diferenciaCuadre = 0
          })
      },

      asignarInformacionVenta(informacion) {
        this.cuadre.valorgaspremium = informacion.gasPremium
        this.cuadre.valorventascredito = informacion.credito
        this.cuadre.valortarjetascredito = informacion.tarjeta
        this.cuadre.valorcheques = informacion.cheque
        this.cuadre.valorbonogas = informacion.bonogas
        this.cuadre.valorpagocomision = informacion.comision
        this.cuadre.donaciones = informacion.donacion
        this.cuadre.valorotros = informacion.otro
        this.cuadre.valorasignaciones = informacion.asignacion
        this.cuadre.pruebasmetro = informacion.prueba
        this.cuadre.valorTraspaso = informacion.traspaso
        this.cuadre.valordescuento = informacion.descuento
      },


   DDataReporteBasico(e){

      },
    imprimirList(){

//datosImprecionAll

this.dialogimprimirListFilt=true
this.datosImprecionAll.fechacuadre=this.cuadre.fechacierre 
console.log("lalal",this.cuadre)
      var _this=this;
      setTimeout(function(){ 
        _this.$refs.ModRepFilt.CrearObjecto = _this.validarObjecto;
      }, 300);
      
    },

      validarObjecto() {

if (!this.$refs.formImpList.validate()) {
  this.$refs.ModRepFilt.detener = true;
  return;
} else {
  this.$refs.ModRepFilt.detener = false;
}


        this.datosImprecionAll.secuencia=this.cuadre.cierrescajasPK.secuencia
        this.datosImprecionAll.caja=this.cuadre.cierrescajasPK.caja


      },

filterlecturasMetroCierreList(LIST){
return LIST.filter((ee) => ee.borrado!=null && ee.borrado==false)
}


    },

    computed: {
      totalesGalones() {
        let totales = {
          gasPremium: 0,
          gasRegular: 0,
          vendido: 0,
          combisa: 0,
        }

        this.cuadre.lecturasMetroCierreList.forEach((lectura) => {
          if (lectura.metro.tipoGas.descripcion.trim().toLowerCase() === "gas regular") {
            totales.gasRegular += lectura.diferencia
          } else if (lectura.metro.tipoGas.descripcion.trim().toLowerCase() === "gas premiun") {
            totales.gasPremium += lectura.diferencia
          }
          totales.combisa += lectura.diferencia
        })
        totales.vendido = totales.gasPremium + totales.gasRegular
        return totales
      },

      totalDenominaciones() {
        let total = 0
        this.cuadre.denominacionCierrecajaList.forEach((element) => {
          total += element.total
        })

        return total
      },

      totalDelDia() {
        let total =
          this.cuadre.valorventascredito +
          this.cuadre.valortarjetascredito +
          this.cuadre.valorcheques +
          this.cuadre.valorbonogas +
          this.cuadre.valorpagocomision +
          this.cuadre.donaciones +
          this.cuadre.valorotros +
          this.cuadre.valorasignaciones +
          this.cuadre.valorcreditodistribuidora +
          this.cuadre.valordistribuidora +
          this.cuadre.pruebasmetro +
          this.cuadre.valorTraspaso

        return total
      },

      totalGeneral() {
        return this.totalDenominaciones + this.totalDelDia
      },

      hasPermisoModificar() {
        let permiso = this.$store.getters.GetdatosInfUsu.usuario.usuarioPermisoPvList
        let hasPermiso = permiso.some((item) => item.fn === 8 && item.op === 50)
        let isAdmin = this.$store.getters.GetdatosInfUsu.usuario.sudo

        if (isAdmin || hasPermiso) {
          return true
        }

        return false
      },

      isEstacionGas() {
        return this.$store.getters.GetConfiguracionGeneral.config.estacion
      },

      dependenciasInformacionVenta() {
        return {
          turno: this.cuadre.turno,
          caja: this.cuadre.caja,
          sucursal: this.cuadre.sucursal,
        }
      },



ActDescBtn() {

  console.log('Inf-->',this.cuadre)
/*cuadre.cierrescajasPK:Object
caja:8
secuencia:3141*/

 if (this.cuadre.cierrescajasPK.secuencia > 0) {
  this.EstadoBtn = {
            BarraTablaDinamicaAprir: true,
            nuevo: true,
            guardar: true,
            eliminar: false,
            anular: false,
            imprimir: true,
            vercuenta: false,
            guardartemporal: false,
            restaurartemporal: false,
            importarDato: false,
            cargarProducto: false,
            ImprimirproductoInv: false,
          }

 }

 if (this.cuadre.cierrescajasPK.secuencia <= 0) { 

  this.EstadoBtn = {
            BarraTablaDinamicaAprir: true,
            nuevo: true,
            guardar: true,
            eliminar: false,
            anular: false,
            imprimir: false,
            vercuenta: false,
            guardartemporal: false,
            restaurartemporal: false,
            importarDato: false,
            cargarProducto: false,
            ImprimirproductoInv: false,
          }
 }




}

    },

    watch: {
      "cuadre.fecha"(val) {
        if (this.hasPermisoModificar || (!this.hasPermisoModificar && !val)) {
          this.EstadoBtn.guardar = true
        } else {
          this.EstadoBtn.guardar = false
        }
      },

      turnoSearch() {
        this.findAllTurnos()
      },

      "cuadre.turno"(newVal, oldVal) {
        this.loadInformacionVentas()
      },

      "cuadre.caja"(newVal, oldVal) {
        this.loadInformacionVentas()
      },

      "cuadre.sucursal"(newVal, oldVal) {
        this.loadInformacionVentas()
      },

      "cuadre.fechacierre"(newVal, oldVal) {
        this.loadInformacionVentas()
      },
    },
  }
</script>

<style>
  #informacion-ventas .v-input {
    margin-bottom: 4px;
  }

  .diferencia-cuadre-row {
    align-items: center;
    display: flex;
    gap: 12px;
    font-size: 16px;
    font-weight: 700;
    color: #212121;
  }

  .diferencia-cuadre-field {
    max-width: 150px;
  }
</style>
